/**
 * Created by mauget on 4/14/16.
 */

import Immutable from 'immutable';
import _ from 'lodash';

//===========================================================================================
// Contains REST messsages
//===========================================================================================
class RestMessages {

    constructor() {
        // codes are vapor after constructor runs
        // At present, we just mutate the error name into a message text.
        const codes = {
            'UNEXPECTED_RESPONSE' :  -2,
            'Unknown server error' :  -1,
            'ALL_OK' :  0,
            'The e-mail and password combination is not recognized' :  1,
            'You are no longer logged in' :  2,
            'You have reached the daily limit for trial accounts. Please try again in 24 hours' :  3,
            'The account name already exists' :  4,
            'The e-mail address already exists' :  5,
            'INVALID_ANONYMOUS_LOGIN' :  6,
            'Some of the parameters are invalid' :  7,
            'The e-mail address is invalid' :  8,
            'The app or report is already being edited by another user' :  9,
            'The library item is not configured correctly' :  10,
            'The e-mail server is no longer available' :  11,
            'The domain username is already assigned to another user' :  12,
            'The app is already deployed' :  13,
            'The app or report is no longer available' :  14,
            'The app does not have a published version' :  15,
            'A published version cannot be overwritten' :  16,
            'This app or report is not active' :  17,
            'The folder cannot be deleted because it is not empty' :  18,
            'You do not have the necessary permissions' :  19,
            'You cannot rename a special folder' :  20,
            'The maximum number of users allowed for this account has been reached' :  21,
            'The maximum number of apps allowed for this account has been reached' :  22,
            'The maximum number of reports allowed for this account has been reached' :  23,
            'The password-link has expired. It is only valid for a short time after it has been sent' :  24,
            'The password-link is no longer valid. It can only be used once and has already been used' :  25,
            'You do not have permission to design the app or report' :  26,
            'The account you are trying to log into has expired. Please contact your account administrator' : 27,
            'The maximum amount of storage allowed for this account has been reached' :  28,
            'The maximum number of instances allowed for this account has been reached' :  29,
            'You cannot delete the account\'s admin user': 30,
            'The e-mail server returned an error': 31,
            'The system has expired' : 32,
            'The notification could not be sent to a user because that user is either inactive, no longer exists or does not have an e-mail address' :  34,
            'The notification could not be sent to a position because it is either inactive or no longer exists' : 35,
            'The notification could not be sent to an e-mail address because it is either empty or has an invalid format' : 36,
            'The notification could not be sent to a role\'s default person because it is incorrectly configured' : 37,
            'The connection is no longer available' : 38,
            'The action is no longer available': 39,
            'MULTIPLE_NOTIFICATIONS' :  41,
            'You cannot delete your own user' :  42,
            'The list is no longer available' : 43,
            'The app-instance is no longer available' :  44,
            'The field was not found' :  45,
            'The field cannot be set to the specified value' :  46,
            'This instance is already being viewed by another user. Please try again later' :  47,
            'The notification could not be sent to a user-group because it is either inactive or no longer exists' : 48,
            'The import file does not contain valid data' :  49,
            'ACTIVE_DIRECTORY_NOT_ENABLED' :  50,
            'INVALID_IP_ADDRESS' :  51,
            'APP_INSTANCE_DOES_NOT_EXIST' :  52,
            'API_NOT_ENABLED' :  53,
            'ACCOUNT_DOES_NOT_EXIST' :  54,
            'ADUSER_DOES_NOT_EXIST' :  55,
            'USER_MUST_BE_LOGGED' :  56,
            'ALLOW_SIGNUP_DISABLE' :  57,
            'You must be domain authenticated to log in to this account' :  58,
            'ANOTHER_USER_EXISTS' :  59,
            'The notification could not be sent to a position because it does not have an assigned user' : 60,
            'The notification could not be sent to a position because the assigned user is either inactive, no longer exists or does not have an e-mail address' : 61,
            'The notification could not be sent to a user-group because it does not contain any users' : 62,
            'The notification could not be sent to a user-group because one of its users is either inactive, no longer exists or does not have an email address' : 63,
            'Only the person who the notification was sent to can view the app-instance' :  64,
            'MAX_ACCOUNTS_REACHED' :  65,
            'The import file does not contain the required item type' :  67,
            'DISABLED_OPTION_OR_INVALID_PASSWORD' :  69,
            'Some of the parameters of the Users Synchronization profile are invalid' :  70,
            'The connection to the directory service could not be made or the username and password were not accepted' :  71,
            'The app has duplicate field id\'s' :  72,
            'DOUBLED_INSTANCE_GUIDS' :  73,
            'APP_VERSION_DOES_NOT_EXISTS' :  74,
            'The maximum number of users with offline app filling enabled has been reached' :  75,
            'This request cannot be completed. You have already successfully submitted a copy of this app instance' :  76,
            'The web service connection requires basic authentication' :  77,
            'NOTIFICATION_DOES_NOT_EXIST' :  78,
            'NO_HTML_APP_AVAILABLE' :  79,
            'ERROR_INVALID_LOGIN_TOKEN' :  80,
            'INACCESSIBLE_FILE_STORAGE_PATH' :  81,
            'NOT_ALLOWED_FOR_ACHIVED_INSTANCE' :  82,
            'The target folder already contains a shortcut to the same item' :  83,
            'INVALID_ARCHIVE_CREDENTIALS' :  84,
            'INVALID_ARCHIVE_DATABASE' :  85,
            'NOT_ALLOWED_FOR_DRAFT_INSTANCE' : 86,
            'Field id not found' : 101,
            'Field name not found' : 102,
            'Field data type not found' : 103,
            'Field internal flag not found' : 104,
            'Data source id not found' : 105,
            'Data source name not found' : 106,
            'Data source type not found' : 107,
            'Data source app id not found' : 108,
            'Report object id not found' : 109,
            'Report object name not found' : 110,
            'Report object data source not found' : 111,
            'At least one column must be selected from the data source' : 112,
            'Report object column id not found' : 113,
            'No expression defined for report object column' : 114,
            'The aggregation cannot be applied to a field' : 115,
            'The aggregation cannot be applied to a boolean field' : 116,
            'Report object operator is not valid' : 117,
            'Filter operator is not valid' : 118,
            'Report object argument type is not valid' : 119,
            'Filter type is not valid' : 120,
            'Reporting object does not have a field specified' : 121,
            'Filter field name is not valid' : 122,
            'Report object argument type not found' : 123,
            'Filter argument type not found' : 124,
            'Report object argument type not supported' : 125,
            'Filter argument type not supported' : 126,
            'Report object argument value not found' : 127,
            'Filter argument value not found' : 128,
            'Report object argument data type not found' : 129,
            'Filter argument data type not found' : 130,
            'The formula of a reporting object field is empty' : 131,
            'The formula of a filter is empty' : 132,
            'Reporting object has a wrong number of operands and operators' : 133,
            'Filter has a wrong number of operands and operators' : 134,
            'For a reporting object, operands and operators must be interpolated' : 135,
            'For a filter, operands and operators must be interpolated' : 136,
            'Reporting object operator type is not supported' : 137,
            'Filter operator type is not supported' : 138,
            'Operator type not supported for a reporting object' : 139,
            'Operator type not supported for a filter' : 140,
            'Reporting object does not support two consecutive comparisons are not supported for' : 141,
            'Filter does not support two consecutive comparisons' : 142,
            'Cannot detect expression type of a reporting object' : 143,
            'Cannot detect expression type of a filter' : 144,
            'Function not supported for a reporting object' : 145,
            'Function not supported for a filter' : 146,
            'Reporting object has an incorrect number of parameters for a function' : 147,
            'Filter has an incorrect number of parameters for a function' : 148,
            'Argument type of a reporting object function is not found' : 149,
            'Argument type of a filter function is not found' : 150,
            'Parameter type of a reporting object function is not valid' : 151,
            'Parameter type of a filter function is not valid' : 152,
            'In a field formula, the a date-time field cannot be used in an arithmetic formula' : 153,
            'In a filter, a date-time field cannot be used in an arithmetic formula' : 154,
            'In a field formula, the a boolean field cannot be used in an arithmetic formula' : 155,
            'In a filter, a boolean field cannot be used in an arithmetic formula' : 156,
            'In a field formula, cannot do arithmetics between a text and a non-text field' : 157,
            'In a filter, arithmetics cannot be done between a text and a non-text field' : 158,
            'In a field formula, a text field can only be added to another text field' : 159,
            'In a filter, a text field can only be added to another text field' : 160,
            'In a field formula, a boolean field can only be compared to another boolean field' : 161,
            'In a filter, a boolean field can only be compared to another boolean field' : 162,
            'In a field formula, cannot compare fields of different data types' : 163,
            'In a filter, cannot compare fields of different data types' : 164,
            'In a field formula, logical operators can only by applied to boolean fields' : 165,
            'In a filter, logical operators can only by applied to boolean fields' : 166,
            'Cannot apply dynamic filter, probably because of changed data-type of a field' : 167,
            'Select first a Sheet on the Google Sheets connection': 168,
            'An error occurred with the authentication process. Please verify with your provider.': 170,
            'The user does not have the required permissions to perform this task.': 171,
            'The user name was not returned by the authentication provider.': 172,
            'The service description (WSDL) is not properly configured. Please check your connection settings.': 189,
            'The file name exceeds the allowed size of 20 characters.': 190,
            'The reporting feature is not enabled for your account.': 191,
            'The file extension does not match file content. Please verify and try again.': 192,
            'The REST/SOAP Sources feature is not enabled for your account.': 193,
            'Maximum number of REST/SOAP Sources reached.': 194,
            'The Connection Agent Connections feature is not enabled for your account.': 195,
            'Maximum number of Connection Agent Connections reached.': 196,
            'The Google Connection feature is not enabled for your account.': 197,
            'Maximum number of Google Connections reached.': 198,       
            'The Web Signature feature is not enabled for your account.': 199,
            'The Encryption feature is not enabled for your account.': 200,
            'The Notification Attachments feature is not enabled for your account.': 201,
            'The Active Directory Sync feature is not enabled for your account.': 202,
            'The Single sign-on feature is not enabled for your account.': 203,
            'Maximum number of Web Signature reached.': 204,
            'Maximum number of Encryption reached.': 205,
            'Maximum number of Notification Attachment reached.': 206,
            'Maximum number of Active Directory Sync reached.': 207,
            'Maximum number of Single sign-on reached.': 208,            
            'The file name contains an invalid character.': 211,
            'The file you are attempting to upload may contain hidden content, which could potentially pose a security risk.': 212,
            'The trial account you are trying to log into has expired.': 213,
            'The file you are attempting to upload contains binary data and is not included in the list of allowed file types for PerfectApps. Please contact support for assistance.': 214,
            'Canceled by user' : 999
        };

        const codes2 = {};

        _.forEach( codes, (v, k) => {
            const k2 = String(k).replace(/_/g, ' ');
            codes2[v] = k2.slice(0,1).toUpperCase() +  k2.slice(1).toLowerCase();
        });
        this._msgs = Immutable.Map( codes2 );

        // this._msgs.map( (v, k) => (console.log(k, v)));

    }

    getTextEditedByOtherUser(){
        return 'App check by other user:';
    }

    //===================================================
    // Returns message for given code
    //===================================================
    codeToMessage(code ) {
        const msg = this._msgs.get( String(code ));
        // console.log( code, msg );
        return msg || 'Unclassified error';
    }
}

const restMessages = new RestMessages();
export default restMessages;
